import { useFormik } from "formik";
import { useState } from "react";
import { themeSchema } from "../../Schema/Schema";
import axiosInstance from "../../axiosInterceptor";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { SwitchToggle } from "../../helper/ImageFormat";

const AddTheme = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editdata = location.state;
  const [loading, setLoading] = useState(false);

  const initialValues = {
    name: editdata?.name || "",
    primaryColor: editdata?.config?.["--primary-color"] || "#000000",
    secondaryColor: editdata?.config?.["--secondary-color"] || "#ffffff",
    fontFamily: editdata?.config?.["--font-family"] || "Roboto",
    fontSize: editdata?.config?.["--font-size"] || "16px",
    fontStyle: editdata?.config?.["--font-style"] || "normal",
    isActive: editdata?.isActive || false,
  };

  const formik = useFormik({
    initialValues,
    validationSchema: themeSchema,
    enableReinitialize: true, 
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const payload = {
          name: values.name,
          isActive: values.isActive,
          config: {
            "--primary-color": values.primaryColor,
            "--secondary-color": values.secondaryColor,
            "--font-family": values.fontFamily,
            "--font-size": values.fontSize,
            "--font-style": values.fontStyle,
          },
        };

        let response;
        if (editdata?.id) {
          response = await axiosInstance.put(`/theme/${editdata.id}`, payload);
        } else {
          response = await axiosInstance.post("/theme", payload);
        }

        if (response.status === 200) {
          toast.success(editdata?.id ? "Theme updated successfully!" : "Theme added successfully!");
          navigate("/theme");
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    },
  });

  const { values, errors, touched, handleChange, handleSubmit, handleBlur,setFieldValue } = formik;

  return (
    <div className="content-wrapper">
      <div className="page-header mt-5 mx-4">
        <h3 className="page-title">{editdata?.id ? "Edit Theme" : "Add Theme"}</h3>
      </div>

      <div className="col-md-12 grid-margin stretch-card">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Theme Name</label>
                    <input
                      type="text"
                      className={`border border-dark   form-control form-control-sm ${errors.name && touched.name ? "is-invalid" : ""}`}
                      name="name"
                      placeholder="Enter theme name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.name && touched.name && <small className="text-danger">{errors.name}</small>}
                  </div>

                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Primary Color</label>
                    <input
                      type="color"
                      className="form-control form-control-color border border-dark   "
                      name="primaryColor"
                      value={values.primaryColor}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Secondary Color</label>
                    <input
                      type="color"
                      className="border border-dark   form-control form-control-color"
                      name="secondaryColor"
                      value={values.secondaryColor}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Font Family</label>
                    <select
                      className={`form-control ${errors.fontFamily && touched.fontFamily ? "is-invalid" : ""}`}
                      name="fontFamily"
                      value={values.fontFamily}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="Roboto">Roboto</option>
                      <option value="Poppins">Poppins</option>
                      <option value="Open Sans">Open Sans</option>
                      <option value="Montserrat">Montserrat</option>
                    </select>
                    {errors.fontFamily && touched.fontFamily && <small className="text-danger">{errors.fontFamily}</small>}
                  </div>

                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Font Size</label>
                    <select
                      className="form-control"
                      name="fontSize"
                      value={values.fontSize}
                      onChange={handleChange}
                    >
                      <option value="14px">Small</option>
                      <option value="16px">Medium</option>
                      <option value="18px">Large</option>
                    </select>
                  </div>

                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Font Style</label>
                    <select
                      className="form-control"
                      name="fontStyle"
                      value={values.fontStyle}
                      onChange={handleChange}
                    >
                      <option value="normal">Normal</option>
                      <option value="italic">Italic</option>
                      <option value="bold">Bold</option>
                    </select>
                  </div>


                  <div className="col-md-12 mt-4">
  <SwitchToggle
    checked={values.isActive}
    onChange={(val) => setFieldValue("isActive", val)}
    activeLabel="Active"
    inactiveLabel="Inactive"
  />
</div>
                </div>

                <div className="text-center mt-5">
                  <button type="button" className="btn btn-danger mr-3" onClick={() => navigate("/theme")}>
                    Cancel
                  </button>

                  <button type="submit" className="btn btn-primary mt-3" disabled={loading}>
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        {editdata?.id ? "Updating..." : "Saving..."}
                      </>
                    ) : editdata?.id ? (
                      "Update Theme"
                    ) : (
                      "Save Theme"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTheme;
